import { render } from "./HeaderInfo.vue?vue&type=template&id=11640640&scoped=true&ts=true"
import script from "./HeaderInfo.vue?vue&type=script&lang=ts"
export * from "./HeaderInfo.vue?vue&type=script&lang=ts"

import "./HeaderInfo.vue?vue&type=style&index=0&id=11640640&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11640640"]])

export default __exports__